
const validateAddress = (userId, addressData) => {
    return fetch(`${process.env.VUE_APP_ADDRESS_VALIDATION_URL}/api/v1/address/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'user-id': userId,
        },
        body: JSON.stringify({
            address: {
                regionCode: 'us',
                locality: addressData.city,
                addressLines: [addressData.addressLines],
            },
        }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Address validation failed');
            }

            return response.json();
        });
};

export const AddressValidationClient = {
    validateAddress,
};
